import {
  SET_PRINCIPALS,
  SET_PRINCIPALS_ERROR,
  CLEAR_PRINCIPALS,
} from "../../constants/action-types";
import { getPrincipalsByAgencyId,
  getPrincipalsByDirectorID
 } from "../../../services/GraphQl/BDSWebService";

export const setPrincipals = (data) => {
  return {
    type: SET_PRINCIPALS,
    payload: data,
  };
}

export const setPrincipalsError = (data) => {
  return {
    type: SET_PRINCIPALS_ERROR,
    payload: data,
  };
};

export const clearPrincipals = (data) => {
  return {
    type: CLEAR_PRINCIPALS,
    payload: data,
  };
};

export const fetchPrincipalsByDirectorID = (directorId) => {
  return async (dispatch) => {
    try {
      const res = await getPrincipalsByDirectorID(directorId);
      if (res) {
        dispatch(setPrincipals(res.data.getPrincipalsByDirectorId));
      }
    } catch (error) {
      dispatch(setPrincipalsError(error.message));
    }
  };
};

export const fetchPrincipals = (agencyId) => {
  return async (dispatch) => {
    try {
      await getPrincipalsByAgencyId(agencyId)
      .then(async (res) => {
        if (res) {
          dispatch(setPrincipals(res));
        }
      })
    } catch (error) {
      dispatch(setPrincipalsError(error.message));
    }
  };
};

export const clearPrincipalsList = () => {
  return (dispatch) => {
    dispatch(clearPrincipals([]));
  };
};


